import Container from './Container.vue';

export default Container;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/form/components/select/components/container/index.ts